import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-500">51</span>
              <span className="text-lg font-heading font-semibold text-foreground-900">
                每日大赛
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              51每日大赛 — 全网最劲爆的吃瓜爆料平台。实时追踪网红塌房、明星八卦、直播翻车等热门事件，每日更新不重样，让你吃瓜吃到饱。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 hover:bg-secondary-300 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 hover:bg-secondary-300 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 hover:bg-secondary-300 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-foreground-600"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-label font-semibold text-foreground-900 mb-4">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-label font-semibold text-foreground-900 mb-4">
              更多分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-label font-semibold text-foreground-900 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-label font-semibold text-foreground-900 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="text-sm text-foreground-600">
                <i className="ri-mail-line mr-1"></i>
                投稿：tougao@51mrdasai.com
              </li>
              <li className="text-sm text-foreground-600">
                <i className="ri-customer-service-line mr-1"></i>
                客服：kefu@51mrdasai.com
              </li>
              <li className="text-sm text-foreground-600">
                <i className="ri-map-pin-line mr-1"></i>
                北京朝阳区
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 51每日大赛 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">用户协议</a>
            <span className="text-secondary-300">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <span className="text-secondary-300">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}